<template>
    <svg
        height="24px"
        width="24px"
        id="folder"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27.489 21.738"
        style="fill: currentColor"
    >
        <g id="Groupe_266" data-name="Groupe 266" transform="translate(0 2.873)">
            <g id="Groupe_265" data-name="Groupe 265" transform="translate(0 0)">
                <path
                    id="Tracé_73"
                    data-name="Tracé 73"
                    d="M22.368,87.785H12.451L10.478,85.44a.337.337,0,0,0-.269-.121h-8A2.223,2.223,0,0,0,0,87.542v14.421a2.223,2.223,0,0,0,2.221,2.221H22.368a2.223,2.223,0,0,0,2.221-2.221V90.005A2.223,2.223,0,0,0,22.368,87.785Z"
                    transform="translate(0 -85.319)"
                />
            </g>
        </g>
        <g id="Groupe_268" data-name="Groupe 268" transform="translate(2.924 0)">
            <g id="Groupe_267" data-name="Groupe 267" transform="translate(0 0)">
                <path
                    id="Tracé_74"
                    data-name="Tracé 74"
                    d="M65.757,45.145h-9.92L53.865,42.8a.337.337,0,0,0-.269-.121h-8A2.221,2.221,0,0,0,43.4,44.6h7.3a1.291,1.291,0,0,1,.992.461l1.684,2h9.473a3.18,3.18,0,0,1,3.175,3.175V61.522a2.221,2.221,0,0,0,1.946-2.2V47.363A2.223,2.223,0,0,0,65.757,45.145Z"
                    transform="translate(-43.4 -42.679)"
                />
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-folder",
});
</script>
